import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.userEnteredSupplementDetails;
export const userEnteredSupplementSelector = (state: RootState) => getState(state).data;
export const userEnteredSupplementIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const userEnteredSupplementErrorSelector = (state: RootState) => getState(state).error;
